import React from 'react'
import { useSeoContentHide } from 'hooks'
import CommunityPostCard from './TeamPublicPage/CommunityPostCard'

const COLORS = {
  primary: '#3366FF',
  primaryDark: '#2952CC',
  primaryLight: '#6699FF',
  background: '#E6F0FF',
}

export default function CommunityPostPage({
  post,
  teamId,
  teamSlug,
  canInteract,
  isOwnerOrAdmin,
  categories,
  currentUser,
  translations,
}) {
  useSeoContentHide()

  const handlePostUpdated = () => {
    window.location.reload()
  }

  const handlePostDeleted = () => {
    window.location.href = `/${teamSlug}/community`
  }

  const handleRequestJoin = () => {
    window.location.href = `/${teamSlug}?consult=1`
  }

  return (
    <CommunityPostCard
      post={post}
      teamId={teamId}
      teamSlug={teamSlug}
      currentUser={currentUser}
      colors={COLORS}
      isOwnerOrAdmin={isOwnerOrAdmin}
      canInteract={canInteract}
      onRequestJoin={currentUser ? handleRequestJoin : undefined}
      onPostUpdated={handlePostUpdated}
      onPostDeleted={handlePostDeleted}
      translations={translations}
      categories={categories}
      expandedView
    />
  )
}
